/* 2026-11-03 · take ?magic= out of the address bar. The box access log showed
   the token in the Referer of API calls made long after the redeem, because the
   URL kept it (a failed redeem never navigates away, and a visitor who is
   already signed in never mounts MagicRedeem). A Referer, a bookmark or a
   screen share would carry a live sign-in token.
   replaceState keeps the history entry, the path, the other params and the
   hash. Single-use and the 15-minute life are server rules and do not change.
   Its own module so WedgeAuthGate does not depend on MagicRedeem for it (a test
   that mocks MagicRedeem must not take this away). */
export function stripMagicParam(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('magic')) return;
    params.delete('magic');
    const qs = params.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
  } catch { /* noop */ }
}
